{
  "version": 1,
  "asset_id": "d40aba70-df51-4eb5-bf8e-650da6744ed6",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/d40aba70-df51-4eb5-bf8e-650da6744ed6/raindrop-sheds-ice.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/d40aba70-df51-4eb5-bf8e-650da6744ed6/raindrop-sheds-ice.mp4",
  "original_filename": "raindrop-sheds-ice.mp4",
  "size": 18234876,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:18:02Z"
}
